import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

const GoogleAnalytics = () => {
  const location = useLocation();
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;

  // Initialize GA4 on mount
  useEffect(() => {
    if (!measurementId) {
      console.warn('GA4_MEASUREMENT_ID is not configured');
      return;
    }

    // Load GA4 script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', {
        page_path: window.location.pathname + window.location.search,
        send_page_view: true
      });
    `;
    document.head.appendChild(script2);

    console.log('✅ Google Analytics 4 initialized');

    return () => {
      // Cleanup scripts on unmount
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, [measurementId]);

  // Track page views on route change
  useEffect(() => {
    if (!measurementId || !window.gtag) return;

    // Send page view event
    window.gtag('config', measurementId, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });

    console.log('📊 GA4 Page View:', location.pathname);
  }, [location, measurementId]);

  return null;
};

export default GoogleAnalytics;
